import { useEffect } from "react";

const GrammarSelectionPage = ({
  worksheet,
  selectedTypes,
  setSelectedTypes,
}) => {
  // Grammar는 단일 섹션으로 처리 - 선택 없이 자동으로 설정
  useEffect(() => {
    if (setSelectedTypes !== undefined) {
      setSelectedTypes([{ key: "grammar", value: "어법테스트" }]);
    }
  }, [setSelectedTypes]);

  // 문제 수 계산
  const documents = worksheet.data?.documents || [];
  const totalQuestions = documents.reduce(
    (sum, doc) => sum + (doc.data?.filter(q => q.is_valid !== false)?.length || 0),
    0
  );

  return (
    <div
      style={{
        padding: "20px",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          marginBottom: "20px",
        }}
      >
        어법 테스트 출제
      </div>
      <div
        style={{
          padding: "16px",
          backgroundColor: "#f9f5ff",
          borderRadius: "8px",
          border: "1px solid #9C2DF0",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            color: "#9C2DF0",
            fontWeight: "600",
          }}
        >
          총 {totalQuestions}문제가 출제됩니다
        </div>
      </div>
    </div>
  );
};

export default GrammarSelectionPage;
